import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'

import { PermissionRoute } from 'features/auth/components/PermissionRoute'
import { ProtectedRoute } from 'features/auth/components/ProtectedRoute'
import { Login } from 'features/auth/pages/Login'
import { ForgotPassword } from 'features/auth/pages/ForgotPassword'
import { Recover2FA } from 'features/auth/pages/Recover2FA'
import { ResetPassword } from 'features/auth/pages/ResetPassword'
import { OrganizationSetup } from 'features/auth/pages/OrganizationSetup'
import { Analytics } from 'features/dashboard/pages/Analytics'
import { Dashboard } from 'features/dashboard/pages/Dashboard'
import { Candidates } from 'features/candidates/pages/Candidates'
import { CandidateDetail } from 'features/candidates/pages/CandidateDetail'
import AutoSyncCenter from 'features/candidates/pages/AutoSyncCenter'
import Matchings from 'features/candidates/pages/Matchings'
import { MatchingDetail } from 'features/candidates/pages/MatchingDetail'
import { Offers } from 'features/offers/pages/Offers'
import { OfferDetail } from 'features/offers/pages/OfferDetail'
import { CreateOffer } from 'features/offers/pages/CreateOffer'
import { Teams } from 'features/teams/pages/Teams'
import { TeamMembers } from 'features/teams/pages/TeamMembers'
import { AIAssistant } from 'features/ai/pages/AIAssistant'
import { RoleManagement } from 'features/roles/pages/RoleManagement'
import { UserManagement } from 'features/users/pages/UserManagement'
import { HiringProcess } from 'features/hiring/pages/HiringProcess'
import { Settings } from 'features/settings/pages/Settings'
import { EmailTemplatesFigma } from 'features/email/pages/EmailTemplatesFigma'
import { SearchResults } from 'features/search/pages/SearchResults'
import { NotificationsCenter } from 'features/notifications/pages/NotificationsCenter'
import { Organizations } from 'features/organizations/pages/Organizations'
import { InterviewLoginPage } from 'features/interview/pages/InterviewLoginPage'
import { InterviewPage } from 'features/interview/pages/InterviewPage'
import { OrganizationStats } from 'features/organizations/pages/OrganizationStats'
import { Layout } from 'components/layout/Layout'
import { ToastContainer } from 'components/ToastContainer'

export const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/organization-setup" element={<OrganizationSetup />} />
      <Route path="/recover-2fa" element={<Recover2FA />} />

      {/* Public Interview Routes */}
      {/* Public Interview Routes */}
      <Route path="/interview_audio/login" element={<InterviewLoginPage />} />
      <Route path="/interview_audio/:slug" element={<InterviewPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route
          path="candidates"
          element={
            <PermissionRoute required="view_candidates">
              <Candidates />
            </PermissionRoute>
          }
        />
        <Route
          path="candidates/:id"
          element={
            <PermissionRoute required="view_candidates">
              <CandidateDetail />
            </PermissionRoute>
          }
        />
        <Route
          path="auto-sync"
          element={
            <PermissionRoute required="view_candidates">
              <AutoSyncCenter />
            </PermissionRoute>
          }
        />
        {/* Use the Candidates page for /teams as well, but open on the "groups" tab */}
        <Route
          path="teams"
          element={
            <PermissionRoute required="manage_teams">
              <Candidates initialTab="groups" />
            </PermissionRoute>
          }
        />
        <Route
          path="teams/:teamId/members"
          element={
            <PermissionRoute required="manage_teams">
              <TeamMembers />
            </PermissionRoute>
          }
        />
        <Route
          path="offers"
          element={
            <PermissionRoute required="view_offers">
              <Offers />
            </PermissionRoute>
          }
        />
        <Route
          path="offers/create"
          element={
            <PermissionRoute required="create_offers">
              <CreateOffer />
            </PermissionRoute>
          }
        />
        <Route
          path="offers/:id"
          element={
            <PermissionRoute required="view_offers">
              <OfferDetail />
            </PermissionRoute>
          }
        />

        <Route
          path="offers/:id/edit"
          element={
            <PermissionRoute required="edit_offers">
              <CreateOffer />
            </PermissionRoute>
          }
        />
        <Route path="ai-assistant" element={<Navigate to="/copilot" replace />} />
        <Route path="ai-agent" element={<Navigate to="/copilot" replace />} />
        <Route
          path="copilot"
          element={
            <PermissionRoute required="use_ai_assistant">
              <AIAssistant />
            </PermissionRoute>
          }
        />
        {/* <Route
          path="analytics"
          element={
            <PermissionRoute required="view_analytics">
              <Analytics />
            </PermissionRoute>
          }
        /> */}
        {/* <Route path="ai-matching" element={<Navigate to="/matchings" replace />} />
        <Route
          path="matchings"
          element={
            <PermissionRoute required="use_ai_matching">
              <Matchings />
            </PermissionRoute>
          }
        />
        <Route
          path="matchings/:id"
          element={
            <PermissionRoute required="use_ai_matching">
              <MatchingDetail />
            </PermissionRoute>
          }
        /> */}
        <Route path="calendar" element={<Navigate to="/offers" replace />} />
        <Route
          path="admin/roles"
          element={
            <PermissionRoute required="view_roles">
              <RoleManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="admin/users"
          element={
            <PermissionRoute required="view_users">
              <UserManagement />
            </PermissionRoute>
          }
        />
        <Route path="admin/email-templates" element={<EmailTemplatesFigma />} />
        <Route
          path="organizations"
          element={
            <Organizations />
          }
        />
        <Route
          path="organizations/:id/stats"
          element={
            <OrganizationStats />
          }
        />
        <Route
          path="hiring-process"
          element={
            <PermissionRoute required="view_hiring_process">
              <HiringProcess />
            </PermissionRoute>
          }
        />
        <Route path="search" element={<SearchResults />} />
        <Route path="settings" element={<Settings />} />
        <Route path="notifications" element={<NotificationsCenter />} />
      </Route>
    </Routes>
    <ToastContainer />
  </Router>
)
